import { render, staticRenderFns } from "./MarketingItem.vue?vue&type=template&id=1f66cc8a&scoped=true&"
import script from "./MarketingItem.vue?vue&type=script&lang=js&"
export * from "./MarketingItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketingItem.vue?vue&type=style&index=0&id=1f66cc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66cc8a",
  null
  
)

export default component.exports